import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
  class: "fenglang-container"
};
const _hoisted_2 = {
  class: "section"
};
const _hoisted_3 = {
  class: "trend-controls"
};
const _hoisted_4 = {
  class: "metrics-wrap"
};
const _hoisted_5 = {
  class: "metrics-grid"
};
const _hoisted_6 = {
  class: "section"
};
const _hoisted_7 = {
  class: "eco-grid"
};
const _hoisted_8 = {
  class: "card eco-list"
};
const _hoisted_9 = {
  class: "eco-rows"
};
const _hoisted_10 = {
  class: "sk-eco-boards"
};
const _hoisted_11 = {
  class: "card eco-detail"
};
const _hoisted_12 = {
  class: "board-levels"
};
const _hoisted_13 = {
  class: "sk-stocks"
};
const _hoisted_14 = {
  class: "section"
};
const _hoisted_15 = {
  class: "card hot-card"
};
const _hoisted_16 = {
  class: "sk-hot-rows"
};
const _hoisted_17 = {
  key: 1,
  class: "state-tip error"
};
const _hoisted_18 = {
  class: "section"
};
const _hoisted_19 = {
  class: "trend-controls"
};
const _hoisted_20 = {
  class: "metrics-wrap"
};
const _hoisted_21 = {
  class: "metrics-grid"
};
const _hoisted_22 = {
  class: "metric-card"
};
const _hoisted_23 = {
  class: "metric-content"
};
const _hoisted_24 = {
  class: "metric-card"
};
const _hoisted_25 = {
  class: "metric-content"
};
const _hoisted_26 = {
  class: "metric-value accent"
};
const _hoisted_27 = {
  class: "metric-card"
};
const _hoisted_28 = {
  class: "metric-content"
};
const _hoisted_29 = {
  class: "metric-value"
};
const _hoisted_30 = {
  class: "metric-card"
};
const _hoisted_31 = {
  class: "metric-content"
};
const _hoisted_32 = {
  class: "metric-value down"
};
const _hoisted_33 = {
  class: "trend-grid",
  ref: "trendGridRef"
};
const _hoisted_34 = {
  class: "chart-card"
};
const _hoisted_35 = {
  class: "chart-body"
};
const _hoisted_36 = {
  ref: "emotionLineChartRef",
  class: "chart"
};
const _hoisted_37 = {
  class: "chart-card"
};
const _hoisted_38 = {
  class: "chart-body"
};
const _hoisted_39 = {
  ref: "emotionBarChartRef",
  class: "chart"
};
const _hoisted_40 = {
  class: "chart-card wide"
};
const _hoisted_41 = {
  class: "chart-body tall"
};
const _hoisted_42 = {
  ref: "leaderChartRef",
  class: "chart"
};
const _hoisted_43 = {
  class: "section"
};
const _hoisted_44 = {
  class: "eco-grid"
};
const _hoisted_45 = {
  class: "card eco-list"
};
const _hoisted_46 = {
  class: "eco-list-head"
};
const _hoisted_47 = {
  class: "week-pager"
};
const _hoisted_48 = ["disabled"];
const _hoisted_49 = {
  class: "pager-info"
};
const _hoisted_50 = ["disabled"];
const _hoisted_51 = {
  class: "eco-rows"
};
const _hoisted_52 = ["onClick"];
const _hoisted_53 = {
  class: "eco-row-top"
};
const _hoisted_54 = {
  class: "eco-date"
};
const _hoisted_55 = {
  class: "eco-week"
};
const _hoisted_56 = {
  class: "eco-bar-wrap"
};
const _hoisted_57 = {
  class: "eco-bar-meta"
};
const _hoisted_58 = {
  class: "down-count"
};
const _hoisted_59 = {
  class: "eco-amount"
};
const _hoisted_60 = {
  class: "up-count"
};
const _hoisted_61 = {
  class: "eco-bar"
};
const _hoisted_62 = {
  class: "eco-boards"
};
const _hoisted_63 = {
  class: "card eco-detail"
};
const _hoisted_64 = {
  class: "eco-detail-head"
};
const _hoisted_65 = {
  class: "eco-detail-title"
};
const _hoisted_66 = {
  class: "eco-detail-date"
};
const _hoisted_67 = {
  class: "board-levels"
};
const _hoisted_68 = {
  class: "level-num"
};
const _hoisted_69 = {
  class: "stock-list"
};
const _hoisted_70 = ["onMouseenter"];
const _hoisted_71 = {
  class: "stock-name"
};
const _hoisted_72 = {
  class: "stock-meta"
};
const _hoisted_73 = {
  class: "stock-code"
};
const _hoisted_74 = {
  key: 0,
  class: "stock-tag"
};
const _hoisted_75 = {
  key: 0,
  class: "eco-empty"
};
const _hoisted_76 = {
  class: "kp-head"
};
const _hoisted_77 = {
  class: "kp-title"
};
const _hoisted_78 = {
  class: "kp-name"
};
const _hoisted_79 = {
  class: "kp-code"
};
const _hoisted_80 = {
  class: "kp-now"
};
const _hoisted_81 = {
  class: "kp-chg"
};
const _hoisted_82 = {
  class: "kp-tabs"
};
const _hoisted_83 = {
  ref: "klineChartRef",
  class: "kp-chart"
};
const _hoisted_84 = {
  key: 0,
  class: "kp-status"
};
const _hoisted_85 = {
  key: 1,
  class: "kp-status kp-err"
};
const _hoisted_86 = {
  key: 2,
  class: "kp-status kp-warn"
};
const _hoisted_87 = {
  class: "section"
};
const _hoisted_88 = {
  class: "card hot-card",
  ref: "hotCard"
};
const _hoisted_89 = {
  class: "eco-list-head"
};
const _hoisted_90 = {
  class: "eco-list-head-left"
};
const _hoisted_91 = {
  key: 0,
  class: "streak-chips"
};
const _hoisted_92 = {
  class: "hot-table",
  ref: "hotTable"
};
const _hoisted_93 = {
  class: "date-cell"
};
const _hoisted_94 = {
  class: "dc-date"
};
const _hoisted_95 = {
  class: "dc-week"
};
const _hoisted_96 = ["data-cell", "data-r", "data-c", "data-name"];
const _hoisted_97 = {
  key: 0,
  class: "hot-badge"
};
const _hoisted_98 = {
  class: "hot-name"
};
const _hoisted_99 = {
  class: "hot-info"
};
const _hoisted_100 = {
  class: "hot-up"
};
const _hoisted_101 = {
  class: "stock-tags"
};
const _hoisted_102 = {
  class: "hot-links"
};
const _hoisted_103 = ["x1", "y1", "x2", "y2"];
const _hoisted_104 = ["cx", "cy"];
const _hoisted_105 = ["cx", "cy"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.loading ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("section", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[10] || (_cache[10] = _createElementVNode("span", {
    class: "sk-bar sk-label"
  }, null, -1)), _cache[11] || (_cache[11] = _createElementVNode("span", {
    class: "sk-bar sk-btn"
  }, null, -1)), _cache[12] || (_cache[12] = _createElementVNode("span", {
    class: "sk-bar sk-btn"
  }, null, -1)), _cache[13] || (_cache[13] = _createElementVNode("span", {
    class: "sk-bar sk-btn"
  }, null, -1)), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, i => {
    return _createElementVNode("div", {
      class: "sk-metric",
      key: i
    });
  }), 64))])])]), _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"trend-grid\" data-v-3e7b38b1><div class=\"chart-card\" data-v-3e7b38b1><div class=\"sk-bar sk-chart-title\" data-v-3e7b38b1></div><div class=\"sk-chart\" data-v-3e7b38b1></div></div><div class=\"chart-card\" data-v-3e7b38b1><div class=\"sk-bar sk-chart-title\" data-v-3e7b38b1></div><div class=\"sk-chart\" data-v-3e7b38b1></div></div><div class=\"chart-card wide\" data-v-3e7b38b1><div class=\"sk-bar sk-chart-title\" data-v-3e7b38b1></div><div class=\"sk-chart tall\" data-v-3e7b38b1></div></div></div>", 1))]), _createElementVNode("section", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_cache[16] || (_cache[16] = _createElementVNode("div", {
    class: "eco-list-head"
  }, [_createElementVNode("span", {
    class: "sk-bar sk-chart-title"
  }), _createElementVNode("span", {
    class: "sk-bar sk-pager"
  })], -1)), _createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, i => {
    return _createElementVNode("div", {
      class: "sk-eco-row",
      key: i
    }, [_cache[15] || (_cache[15] = _createStaticVNode("<div class=\"sk-eco-top\" data-v-3e7b38b1><span class=\"sk-bar sk-date\" data-v-3e7b38b1></span><span class=\"sk-bar sk-week\" data-v-3e7b38b1></span><span class=\"sk-bar sk-idx\" data-v-3e7b38b1></span></div><div class=\"sk-eco-bar\" data-v-3e7b38b1></div>", 2)), _createElementVNode("div", _hoisted_10, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, j => {
      return _createElementVNode("span", {
        class: "sk-board",
        key: j
      });
    }), 64))])]);
  }), 64))])]), _createElementVNode("div", _hoisted_11, [_cache[18] || (_cache[18] = _createElementVNode("div", {
    class: "eco-detail-head"
  }, [_createElementVNode("span", {
    class: "sk-bar sk-chart-title"
  })], -1)), _createElementVNode("div", _hoisted_12, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([2, 4, 6, 7], (n, i) => {
    return _createElementVNode("div", {
      class: "sk-level",
      key: i
    }, [_cache[17] || (_cache[17] = _createElementVNode("div", {
      class: "sk-level-label"
    }, null, -1)), _createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(n, j => {
      return _openBlock(), _createElementBlock("div", {
        class: "sk-stock",
        key: j
      });
    }), 128))])]);
  }), 64))])])])]), _createElementVNode("section", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[20] || (_cache[20] = _createElementVNode("div", {
    class: "eco-list-head"
  }, [_createElementVNode("span", {
    class: "sk-bar sk-chart-title"
  })], -1)), _createElementVNode("div", _hoisted_16, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, i => {
    return _createElementVNode("div", {
      class: "sk-hot-row",
      key: i
    }, [_cache[19] || (_cache[19] = _createElementVNode("div", {
      class: "sk-hot-date"
    }, null, -1)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, j => {
      return _createElementVNode("div", {
        class: "sk-hot-cell",
        key: j
      });
    }), 64))]);
  }), 64))])])])], 64)) : $data.errorMsg ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString($data.errorMsg), 1)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createElementVNode("section", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[29] || (_cache[29] = _createElementVNode("span", {
    class: "tc-label"
  }, "时间范围", -1)), _createElementVNode("button", {
    class: _normalizeClass(["tc-btn", {
      active: $data.rangeDays === 7
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.zoomAll(7))
  }, "近7日", 2), _createElementVNode("button", {
    class: _normalizeClass(["tc-btn", {
      active: $data.rangeDays === 15
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $options.zoomAll(15))
  }, "近15日", 2), _createElementVNode("button", {
    class: _normalizeClass(["tc-btn", {
      active: $data.rangeDays === 0
    }]),
    onClick: _cache[2] || (_cache[2] = $event => $options.zoomAll(0))
  }, "全部", 2), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[22] || (_cache[22] = _createStaticVNode("<div class=\"metric-header\" data-v-3e7b38b1><svg class=\"metric-icon text-amber-500\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-3e7b38b1><path d=\"m12 14 4-4\" data-v-3e7b38b1></path><path d=\"M3.34 19a10 10 0 1 1 17.32 0\" data-v-3e7b38b1></path></svg><span class=\"metric-label\" data-v-3e7b38b1>情绪温度·高位晋级率</span></div>", 1)), _createElementVNode("div", {
    class: _normalizeClass(["metric-value", $options.mood.cls])
  }, [_createTextVNode(_toDisplayString($options.emotionSummary.highPromo), 1), _cache[21] || (_cache[21] = _createElementVNode("span", {
    class: "unit-sm"
  }, "%", -1))], 2)])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[24] || (_cache[24] = _createStaticVNode("<div class=\"metric-header\" data-v-3e7b38b1><svg class=\"metric-icon text-blue-500\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-3e7b38b1><path d=\"M16 7h6v6\" data-v-3e7b38b1></path><path d=\"m22 7-8.5 8.5-5-5L2 17\" data-v-3e7b38b1></path></svg><span class=\"metric-label\" data-v-3e7b38b1>1进2成功率</span></div>", 1)), _createElementVNode("div", _hoisted_26, [_createTextVNode(_toDisplayString($options.emotionSummary.p12), 1), _cache[23] || (_cache[23] = _createElementVNode("span", {
    class: "unit-sm"
  }, "%", -1))])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_cache[26] || (_cache[26] = _createElementVNode("div", {
    class: "metric-header"
  }, [_createElementVNode("svg", {
    class: "metric-icon text-rose-500",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [_createElementVNode("path", {
    d: "M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4"
  })]), _createElementVNode("span", {
    class: "metric-label"
  }, "炸板率")], -1)), _createElementVNode("div", _hoisted_29, [_createTextVNode(_toDisplayString($options.emotionSummary.brokenRatio), 1), _cache[25] || (_cache[25] = _createElementVNode("span", {
    class: "unit-sm"
  }, "%", -1))])])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_cache[28] || (_cache[28] = _createElementVNode("div", {
    class: "metric-header"
  }, [_createElementVNode("svg", {
    class: "metric-icon text-teal-500",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [_createElementVNode("path", {
    d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"
  })]), _createElementVNode("span", {
    class: "metric-label"
  }, "跌停 / 炸板")], -1)), _createElementVNode("div", _hoisted_32, [_createTextVNode(_toDisplayString($options.emotionSummary.limitDown), 1), _cache[27] || (_cache[27] = _createElementVNode("span", {
    class: "divider"
  }, "/", -1)), _createTextVNode(_toDisplayString($options.emotionSummary.broken), 1)])])])])])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_cache[30] || (_cache[30] = _createElementVNode("div", {
    class: "chart-head"
  }, "连板晋级率趋势", -1)), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, null, 512)])]), _createElementVNode("div", _hoisted_37, [_cache[31] || (_cache[31] = _createElementVNode("div", {
    class: "chart-head"
  }, "市场亏钱效应", -1)), _createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, null, 512)])]), _createElementVNode("div", _hoisted_40, [_cache[32] || (_cache[32] = _createElementVNode("div", {
    class: "chart-head"
  }, "龙头股高度轨迹", -1)), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, null, 512)])])], 512)]), _createElementVNode("section", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_cache[33] || (_cache[33] = _createElementVNode("span", {
    class: "eco-list-title"
  }, "连板生态", -1)), _createElementVNode("div", _hoisted_47, [_createElementVNode("button", {
    class: "pager-btn",
    disabled: $data.currentWeek >= $options.weeks.length - 1,
    onClick: _cache[3] || (_cache[3] = (...args) => $options.prevWeek && $options.prevWeek(...args))
  }, "上一周", 8, _hoisted_48), _createElementVNode("span", _hoisted_49, "第 " + _toDisplayString($data.currentWeek + 1) + " / " + _toDisplayString($options.weeks.length) + " 周", 1), _createElementVNode("button", {
    class: "pager-btn",
    disabled: $data.currentWeek <= 0,
    onClick: _cache[4] || (_cache[4] = (...args) => $options.nextWeek && $options.nextWeek(...args))
  }, "下一周", 8, _hoisted_50)])]), _createElementVNode("div", _hoisted_51, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.visibleWeek, row => {
    return _openBlock(), _createElementBlock("button", {
      key: row.date,
      class: _normalizeClass(["eco-row", {
        active: row.date === $data.selectedBoardDate
      }]),
      onClick: $event => $options.selectDate(row)
    }, [_createElementVNode("div", _hoisted_53, [_createElementVNode("span", _hoisted_54, _toDisplayString(row.date.slice(5)), 1), _createElementVNode("span", _hoisted_55, _toDisplayString(row.week), 1), _createElementVNode("span", {
      class: _normalizeClass(["eco-index", row.indexRate >= 0 ? 'up' : 'down'])
    }, "上证 " + _toDisplayString(row.indexRate > 0 ? '+' : '') + _toDisplayString(row.indexRate) + "%", 3)]), _createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("span", _hoisted_58, "跌 " + _toDisplayString(row.downCount), 1), _createElementVNode("span", _hoisted_59, _toDisplayString(row.amount) + "亿", 1), _createElementVNode("span", _hoisted_60, "涨 " + _toDisplayString(row.upCount), 1)]), _createElementVNode("div", _hoisted_61, [_createElementVNode("div", {
      class: "eco-bar-down",
      style: _normalizeStyle({
        width: row.downPercent + '%'
      })
    }, null, 4), _createElementVNode("div", {
      class: "eco-bar-up",
      style: _normalizeStyle({
        width: row.upPercent + '%'
      })
    }, null, 4)])]), _createElementVNode("div", _hoisted_62, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, b => {
      return _createElementVNode("span", {
        key: b,
        class: _normalizeClass(["eco-board", {
          hot: $options.boardCount(row, b) >= 3
        }])
      }, _toDisplayString($options.boardCount(row, b)), 3);
    }), 64))])], 10, _hoisted_52);
  }), 128))])]), _createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("span", _hoisted_66, _toDisplayString($data.selectedBoardDate), 1), _cache[34] || (_cache[34] = _createElementVNode("span", {
    class: "eco-detail-sub"
  }, "连板身位图", -1))]), _cache[35] || (_cache[35] = _createElementVNode("div", {
    class: "eco-detail-tools"
  }, [_createElementVNode("span", {
    class: "eco-detail-tip"
  }, "点击左侧日期查看当日连板")], -1))]), _createElementVNode("div", _hoisted_67, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.boardLevelData, level => {
    return _openBlock(), _createElementBlock("div", {
      class: "level-item",
      key: level.num
    }, [_createElementVNode("div", {
      class: _normalizeClass(["level-label", level.labelClass])
    }, [_createElementVNode("div", _hoisted_68, _toDisplayString(level.num), 1), _cache[36] || (_cache[36] = _createElementVNode("div", {
      class: "level-text"
    }, "连板", -1))], 2), _createElementVNode("div", _hoisted_69, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(level.stocks, stock => {
      return _openBlock(), _createElementBlock("div", {
        class: "stock-card",
        key: stock.code,
        onMouseenter: $event => $options.showStockCard(stock, $event),
        onMouseleave: _cache[5] || (_cache[5] = $event => $options.scheduleHide())
      }, [_createElementVNode("div", _hoisted_71, _toDisplayString(stock.name), 1), _createElementVNode("div", _hoisted_72, [_createElementVNode("span", _hoisted_73, _toDisplayString(stock.code), 1), stock.tag ? (_openBlock(), _createElementBlock("span", _hoisted_74, _toDisplayString(stock.tag), 1)) : _createCommentVNode("", true)])], 40, _hoisted_70);
    }), 128))])]);
  }), 128)), !$options.boardLevelData.length ? (_openBlock(), _createElementBlock("div", _hoisted_75, "当日无连板数据")) : _createCommentVNode("", true)])])])]), _createVNode(_Transition, {
    name: "fade"
  }, {
    default: _withCtx(() => [$data.hoverStock ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "kline-popup",
      style: _normalizeStyle($data.popupStyle),
      onMouseenter: _cache[8] || (_cache[8] = $event => $options.cancelHide()),
      onMouseleave: _cache[9] || (_cache[9] = $event => $options.scheduleHide())
    }, [_createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_createElementVNode("span", _hoisted_78, _toDisplayString($data.hoverStock.name), 1), _createElementVNode("span", _hoisted_79, _toDisplayString($data.hoverStock.code), 1)]), _createElementVNode("div", {
      class: _normalizeClass(["kp-price", $options.priceCls])
    }, [_createElementVNode("span", _hoisted_80, _toDisplayString($options.kpPrice), 1), _createElementVNode("span", _hoisted_81, _toDisplayString($options.kpChange), 1)], 2)]), _createElementVNode("div", _hoisted_82, [_createElementVNode("button", {
      class: _normalizeClass(["kp-tab", {
        active: $data.klineMode === 'intraday'
      }]),
      onClick: _cache[6] || (_cache[6] = $event => $options.setKlineMode('intraday'))
    }, "分时", 2), _createElementVNode("button", {
      class: _normalizeClass(["kp-tab", {
        active: $data.klineMode === 'daily'
      }]),
      onClick: _cache[7] || (_cache[7] = $event => $options.setKlineMode('daily'))
    }, "日K", 2)]), _createElementVNode("div", _hoisted_83, null, 512), $data.klineLoading ? (_openBlock(), _createElementBlock("div", _hoisted_84, "加载中…")) : _createCommentVNode("", true), $data.klineError ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString($data.klineError), 1)) : _createCommentVNode("", true), $data.klineWarn ? (_openBlock(), _createElementBlock("div", _hoisted_86, "⚠ " + _toDisplayString($data.klineWarn), 1)) : _createCommentVNode("", true)], 36)) : _createCommentVNode("", true)]),
    _: 1
  }), _createElementVNode("section", _hoisted_87, [_createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_cache[37] || (_cache[37] = _createElementVNode("span", {
    class: "eco-list-title"
  }, "板块轮动", -1)), $options.hotStreaks.length ? (_openBlock(), _createElementBlock("div", _hoisted_91, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.hotStreaks, s => {
    return _openBlock(), _createElementBlock("span", {
      class: "streak-chip",
      key: s.name
    }, _toDisplayString(s.name) + " " + _toDisplayString(s.streak) + "日", 1);
  }), 128))])) : _createCommentVNode("", true)])]), _createElementVNode("table", _hoisted_92, [_cache[38] || (_cache[38] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", null, "日期"), _createElementVNode("th", null, "热点 1"), _createElementVNode("th", null, "热点 2"), _createElementVNode("th", null, "热点 3"), _createElementVNode("th", null, "热点 4"), _createElementVNode("th", null, "热点 5")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sectorData, (row, rIndex) => {
    return _openBlock(), _createElementBlock("tr", {
      key: row.date
    }, [_createElementVNode("td", _hoisted_93, [_createElementVNode("div", _hoisted_94, _toDisplayString(row.date), 1), _createElementVNode("div", _hoisted_95, _toDisplayString(row.week), 1)]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, i => {
      return _createElementVNode("td", {
        key: i,
        class: _normalizeClass(["hot-cell", {
          empty: !row.hots[i - 1],
          continued: row.hots[i - 1] && $options.streakMap[rIndex + '-' + (i - 1)] >= 2
        }]),
        "data-cell": rIndex + '-' + (i - 1),
        "data-r": rIndex,
        "data-c": i - 1,
        "data-name": row.hots[i - 1] ? row.hots[i - 1].name : ''
      }, [row.hots[i - 1] ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [$options.streakMap[rIndex + '-' + (i - 1)] >= 2 ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString($options.streakMap[rIndex + '-' + (i - 1)]), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_98, _toDisplayString(row.hots[i - 1].name), 1), _createElementVNode("div", _hoisted_99, [_createElementVNode("span", _hoisted_100, "涨停 " + _toDisplayString(row.hots[i - 1].stockCount) + "家", 1), _createElementVNode("span", null, "最高 " + _toDisplayString(row.hots[i - 1].maxBoard) + "板", 1)]), _createElementVNode("div", _hoisted_101, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.hots[i - 1].stocks, (s, j) => {
        return _openBlock(), _createElementBlock("span", {
          class: "stock-tag",
          key: j
        }, _toDisplayString(s.name) + " " + _toDisplayString(s.board) + "b", 1);
      }), 128))])], 64)) : _createCommentVNode("", true)], 10, _hoisted_96);
    }), 64))]);
  }), 128))])], 512), _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_102, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.linkLines, (l, li) => {
    return _openBlock(), _createElementBlock("line", {
      key: li,
      x1: l.x1,
      y1: l.y1,
      x2: l.x2,
      y2: l.y2
    }, null, 8, _hoisted_103);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.linkLines, (l, li) => {
    return _openBlock(), _createElementBlock("circle", {
      key: 's' + li,
      cx: l.x1,
      cy: l.y1,
      r: "2.5"
    }, null, 8, _hoisted_104);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.linkLines, (l, li) => {
    return _openBlock(), _createElementBlock("circle", {
      key: 'e' + li,
      cx: l.x2,
      cy: l.y2,
      r: "2.5"
    }, null, 8, _hoisted_105);
  }), 128))], 512)), [[_vShow, $data.linkLines.length]])], 512)])], 64))]);
}